(function () {
  'use strict';
  if (!('IntersectionObserver' in window)) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-in-view');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.12, rootMargin: '0px 0px -60px 0px' });
  document.querySelectorAll('.lnw-process-step,.lnw-product-card,.lnw-coat-card,.lnw-pro__copy,.lnw-pro__benefits,.lnw-faq-item').forEach(function (el) {
    observer.observe(el);
  });
})();
